var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0711 0.642578H1.92829C1.21821 0.642578 0.642578 1.21821 0.642578 1.92829V9.64258C0.642578 10.3527 1.21821 10.9283 1.92829 10.9283H16.0711C16.7812 10.9283 17.3569 10.3527 17.3569 9.64258V1.92829C17.3569 1.21821 16.7812 0.642578 16.0711 0.642578Z",
    stroke: "url(#paint0_linear_2146_779)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99986 7.71359C10.065 7.71359 10.9284 6.85014 10.9284 5.78502C10.9284 4.7199 10.065 3.85645 8.99986 3.85645C7.93474 3.85645 7.07129 4.7199 7.07129 5.78502C7.07129 6.85014 7.93474 7.71359 8.99986 7.71359Z",
    stroke: "url(#paint1_linear_2146_779)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92871 14.1426H16.0716M3.21443 17.3569H14.7859",
    stroke: "url(#paint2_linear_2146_779)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_779",
    x1: 0.642578,
    y1: 5.78544,
    x2: 17.3569,
    y2: 5.78544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_779",
    x1: 7.07129,
    y1: 5.78502,
    x2: 10.9284,
    y2: 5.78502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_779",
    x1: 1.92871,
    y1: 15.7497,
    x2: 16.0716,
    y2: 15.7497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyHighlighted);
export default __webpack_public_path__ + "static/media/money_highlighted.5e8ff3952808a451fa39534981e79f04.svg";
export { ForwardRef as ReactComponent };